
import React, { useState, useEffect, useRef } from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Button } from './components/Button';
import { ContactModal } from './components/ContactModal';
import { AndorraBanner } from './components/AndorraBanner';
import { TicketIcon, MagnifyingGlassIcon, GavelIcon } from './components/IconComponents';
import { PrivacyPolicyModal } from './components/PrivacyPolicyModal';
import { CookiePolicyModal } from './components/CookiePolicyModal';
import { LegalNoticeModal } from './components/LegalNoticeModal';
import { AboutUsModal } from './components/AboutUsModal';
import { MultasEuModal } from './components/MultasEuModal';
import { PeritajesEuModal } from './components/PeritajesEuModal';
import { JuzgadosEuModal } from './components/JuzgadosEuModal';
import { PricesModal } from './components/PricesModal';
import { DelegationsModal } from './components/DelegationsModal';
import { FranchiseModal } from './components/FranchiseModal';
import { JobsModal } from './components/JobsModal';
import { LoginModal } from './components/LoginModal';
import { RegisterModal } from './components/RegisterModal';
import CreaAdModal from './components/CreaAdModal';
import { Dashboard } from './components/dashboard/Dashboard';
import UserDashboard from './components/user-dashboard/UserDashboard';
import { FaqModal } from './components/FaqModal';
import { SuccessStoriesModal } from './components/SuccessStoriesModal';
import { CountryGuideModal } from './components/CountryGuideModal';
import { ServicesSlider } from './components/ServicesSlider';
import { WhatsAppButton } from './components/WhatsAppButton';
import { DenunciaModal } from './components/DenunciaModal';
import { NormativasVariasModal } from './components/NormativasVariasModal';
import { PartnersModal } from './components/PartnersModal';
import { ThankYouModal } from './components/ThankYouModal';

interface SectionWithModalTriggerProps {
  onOpenModal: (subject?: string | React.MouseEvent<HTMLButtonElement>) => void;
}

const slides = [
  // Multas de Tráfico
  { 
    prefix: "de ", 
    text: "Multas de Tráfico",
    description: "Recurrimos sus multas en vía administrativa y contencioso-administrativa.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/multas/image_1.png', position: 'center 30%' }
  },
  { 
    prefix: "de ", 
    text: "Multas de Tráfico",
    description: "¿Una multa? Estudiamos su caso para anularla y que no pague de más.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/multas/image_2.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Multas de Tráfico",
    description: "No pague multas injustas. Luchamos por la cancelación de su sanción.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/multas/image_3.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Multas de Tráfico",
    description: "Abogados especialistas en multas de tráfico y recuperación de puntos del carnet.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/multas/image_4.png', position: 'center 40%' }
  },
  { 
    prefix: "de ", 
    text: "Multas de Tráfico",
    description: "Recursos contra multas de aparcamiento (ORA, SER), cámaras y zonas de bajas emisiones.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/multas/image_5.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Multas de Tráfico",
    description: "No pierda tiempo ni dinero. Nos encargamos de gestionar y recurrir sus multas.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/multas/image_6.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Multas de Tráfico",
    description: "Su tranquilidad es nuestra prioridad. Deje la defensa de sus multas en nuestras manos.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/multas/image_7.png', position: 'center 30%' }
  },
  { 
    prefix: "de ", 
    text: "Multas de Tráfico",
    description: "Analizamos sus multas sin compromiso. Aumente sus posibilidades de éxito.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/multas/image_8.png', position: 'center center' }
  },
  
  // Peritajes Privados
  { 
    prefix: "de ", 
    text: "Peritajes Privados",
    description: "Informes periciales técnicos y dictámenes especializados para aportar claridad.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/peritajes/image_1.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Peritajes Privados",
    description: "Análisis técnico y evaluación experta para tomar decisiones estratégicas.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/peritajes/image_2.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Peritajes Privados",
    description: "Pruebas periciales y ratificación judicial. El soporte técnico que su caso necesita.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/peritajes/image_3.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Peritajes Privados",
    description: "La evidencia objetiva que necesita: informes para la resolución de conflictos.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/peritajes/image_4.png', position: 'center center' }
  },
   { 
    prefix: "de ", 
    text: "Peritajes Privados",
    description: "Tasaciones y valoraciones profesionales de bienes, activos y daños.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/peritajes/image_5.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Peritajes Privados",
    description: "Aportamos claridad técnica a situaciones complejas mediante informes rigurosos.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/peritajes/image_6.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Peritajes Privados",
    description: "El diagnóstico técnico que necesita para avanzar. Servicios periciales a su medida.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/peritajes/image_7.png', position: 'center center' }
  },
  { 
    prefix: "de ", 
    text: "Peritajes Privados",
    description: "Investigación y reconstrucción de hechos. Su experto de confianza para el dictamen pericial.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/peritajes/image_8.png', position: 'center center' }
  },
  
  // en los Tribunales
  { 
    prefix: "", 
    text: "en los Tribunales",
    description: "Representación letrada ante todas las instancias judiciales. Su caso, en manos expertas.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/juzgados/image_1.png', position: 'center 40%' }
  },
  { 
    prefix: "", 
    text: "en los Tribunales",
    description: "Defensa penal, recursos y reclamaciones civiles. Cubrimos todas las áreas de la litigación.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/juzgados/image_2.png', position: 'center center' }
  },
  { 
    prefix: "", 
    text: "en los Tribunales",
    description: "Estrategia procesal y defensa en juicio oral para maximizar sus posibilidades de éxito.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/juzgados/image_3.png', position: 'center center' }
  },
  { 
    prefix: "", 
    text: "en los Tribunales",
    description: "Litigación experta para proteger sus intereses. Luchamos por una sentencia favorable.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/juzgados/image_4.png', position: 'center center' }
  },
  { 
    prefix: "", 
    text: "en los Tribunales",
    description: "Su voz ante los jueces y tribunales. Argumentamos su caso con firmeza y convicción.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/juzgados/image_5.png', position: 'center 40%' }
  },
  { 
    prefix: "", 
    text: "en los Tribunales",
    description: "No se enfrente solo a la justicia. Le acompañamos y representamos con rigor y profesionalidad.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/juzgados/image_6.png', position: 'center center' }
  },
  { 
    prefix: "", 
    text: "en los Tribunales",
    description: "Desde la demanda inicial hasta el último recurso, defendemos su causa con tenacidad.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/juzgados/image_7.png', position: 'center center' }
  },
  { 
    prefix: "", 
    text: "en los Tribunales",
    description: "Llevamos su caso a los tribunales con la máxima preparación y dedicación.",
    image: { url: 'https://datos.us/g/multas.eu/graphs/juzgados/image_8.png', position: 'center center' }
  },
];


const HeroSection: React.FC<SectionWithModalTriggerProps> = ({ onOpenModal }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [activeLayer, setActiveLayer] = useState(0);

  // Preload all images on component mount
  useEffect(() => {
    let loadedCount = 0;
    slides.forEach(slide => {
      const img = new Image();
      img.src = slide.image.url;
      img.onload = () => {
        loadedCount++;
        if (loadedCount === slides.length) {
          setImagesLoaded(true);
        }
      };
      img.onerror = () => {
        console.error(`Failed to load image: ${slide.image.url}`);
        loadedCount++;
        if (loadedCount === slides.length) {
          setImagesLoaded(true); // Still proceed even if an image fails
        }
      };
    });
  }, []);

  // Start the slideshow only when images are loaded
  useEffect(() => {
    if (!imagesLoaded) return;

    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % slides.length);
      setActiveLayer(prevLayer => (prevLayer + 1) % 2);
    }, 4000);

    return () => clearInterval(timer);
  }, [imagesLoaded]);

  const currentContent = slides[currentIndex];
  
  const getImageUrlForLayer = (layer: number) => {
    if (!imagesLoaded) return slides[0].image.url;
    
    if (layer === activeLayer) {
        return slides[currentIndex].image.url;
    }
    const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
    return slides[prevIndex].image.url;
  };

  const getImagePositionForLayer = (layer: number) => {
    if (!imagesLoaded) return slides[0].image.position;

    if (layer === activeLayer) {
        return slides[currentIndex].image.position;
    }
    const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
    return slides[prevIndex].image.position;
  };

  return (
    <section className="text-white relative w-full h-[80vh] min-h-[500px] md:h-auto md:aspect-[21/9] md:max-h-[768px]">
      <div className="absolute inset-0">
        {/* Layer 0 */}
        <div
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out"
          style={{
            backgroundImage: `url('${getImageUrlForLayer(0)}')`,
            backgroundPosition: getImagePositionForLayer(0),
            opacity: !imagesLoaded || activeLayer === 0 ? 1 : 0,
          }}
        />
        {/* Layer 1 */}
        <div
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out"
          style={{
            backgroundImage: `url('${getImageUrlForLayer(1)}')`,
            backgroundPosition: getImagePositionForLayer(1),
            opacity: imagesLoaded && activeLayer === 1 ? 1 : 0,
          }}
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent"></div>
      
      <div className="container mx-auto px-6 h-full flex flex-col justify-end md:justify-center text-center relative z-10">
        <h1 className="text-4xl md:text-7xl font-black mb-4 md:mb-6 tracking-tighter text-stroke-lg">
          <span key={currentIndex} className="inline-block animate-fade-in">
            Defensa Experta {currentContent.prefix}<span className="text-yellow-400">{currentContent.text}</span> en toda Europa.
          </span>
        </h1>
        <p className="text-xl md:text-2xl mb-6 text-slate-200 text-stroke-md">
          Fuimos Multas.com. Crecimos como Multas.org. Ahora, somos <span className="font-bold text-yellow-400">Multas.EU</span> y mucho mas...
        </p>
        <div className="h-20 flex items-center justify-center mb-10">
          <p key={currentIndex + '-desc'} className="text-lg md:text-xl max-w-3xl mx-auto text-slate-300 animate-fade-in text-stroke-md">
            {currentContent.description}
          </p>
        </div>
        <div className="w-full md:text-center text-left md:w-auto">
             <Button
                onClick={onOpenModal}
                variant="primary"
                className="px-6 py-3 text-base md:px-8 md:py-4 md:text-lg"
            >
                CONSULTA TU CASO AHORA
            </Button>
        </div>
        <div className="h-16 shrink-0 md:hidden" aria-hidden="true"></div>
      </div>

      {/* AI Powered Banner */}
      <div className="absolute bottom-2 right-2 md:bottom-6 md:right-6 z-20 flex items-center gap-1 md:gap-2 rounded-lg bg-slate-900/70 p-1.5 md:p-2 shadow-xl backdrop-blur-sm">
        <p className="text-[10px] md:text-sm font-bold tracking-wide animate-neon-text text-right">
          Potenciado por<br/>Inteligencia Artificial
        </p>
        <img 
          src="https://datos.us/g/multas.eu/graphs/multas/logo_estrella_IA.png" 
          alt="Icono de IA" 
          className="h-8 w-8 md:h-12 md:w-12 object-contain animate-slow-pulse"
        />
      </div>

    </section>
  );
};


interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  theme: 'blue' | 'yellow' | 'red';
  onClick?: () => void;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ icon, title, description, theme, onClick }) => {
  const isClickable = !!onClick;
  
  const cardClasses = `bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl shadow-lg transition-all duration-300 text-center flex flex-col items-center h-full border border-slate-700 ${
    isClickable ? 'hover:shadow-yellow-400/20 hover:shadow-2xl hover:-translate-y-2 cursor-pointer hover:border-yellow-400' : 'hover:shadow-2xl'
  }`;

  const themeStyles = {
    blue: {
      iconBg: 'bg-blue-900/50',
      iconText: 'text-blue-400',
    },
    yellow: {
      iconBg: 'bg-yellow-900/50',
      iconText: 'text-yellow-400',
    },
    red: {
      iconBg: 'bg-red-900/50',
      iconText: 'text-red-400',
    },
  };
  
  const currentTheme = themeStyles[theme];
  
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={cardClasses}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={isClickable ? 0 : -1}
      role={isClickable ? 'button' : undefined}
      aria-label={isClickable ? `Aprender más sobre ${title}` : undefined}
    >
      <div className={`w-28 h-28 rounded-full flex items-center justify-center mb-6 ${currentTheme.iconBg} border-2 border-slate-700 transition-colors group-hover:border-yellow-400`}>
        <div className={`${currentTheme.iconText} transition-transform group-hover:scale-110`}>{icon}</div>
      </div>
      <h3 className="text-xl font-semibold text-white mb-3">{title}</h3>
      <p className="text-slate-300 leading-relaxed">{description}</p>
    </div>
  );
};


interface ServicesSectionProps {
  onOpenMultasEuModal: () => void;
  onOpenPeritajesEuModal: () => void;
  onOpenJuzgadosEuModal: () => void;
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ 
  onOpenMultasEuModal, 
  onOpenPeritajesEuModal, 
  onOpenJuzgadosEuModal 
}) => {
  return (
    <section className="py-24 bg-slate-900">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-extrabold text-center text-white mb-4">
          Una cobertura 360º para tu total tranquilidad.
        </h2>
        <p className="text-lg text-center text-slate-300 mb-16 max-w-3xl mx-auto">
          Con Multas.EU, hemos integrado nuestros servicios para ofrecerte un escudo técnico-legal completo. Ya no necesitas buscar en varios sitios, lo tienes todo aquí.
        </p>
        <div className="grid md:grid-cols-3 gap-8 group">
          <ServiceCard
            icon={<TicketIcon className="w-16 h-16" />}
            title="Multas.EU - Defensa de Sanciones"
            description="Recurrimos y gestionamos tus multas de tráfico, velocidad, aparcamiento, alcoholemia y más. Expertos en la legislación de cada país europeo."
            onClick={onOpenMultasEuModal}
            theme="blue"
          />
          <ServiceCard
            icon={<MagnifyingGlassIcon className="w-16 h-16" />}
            title="Peritajes.EU - Informes de Expertos"
            description="¿Necesitas un informe pericial para un accidente o reconstrucción de hechos? Nuestro equipo de peritos te proporciona la prueba técnica que necesitas para ganar."
            onClick={onOpenPeritajesEuModal}
            theme="yellow"
          />
          <ServiceCard
            icon={<GavelIcon className="w-16 h-16" />}
            title="Juzgados.EU - Representación Legal"
            description="Si tu caso requiere llegar a la vía judicial, nuestros abogados especialistas te representarán con firmeza y profesionalidad en los juzgados."
            onClick={onOpenJuzgadosEuModal}
            theme="red"
          />
        </div>
      </div>
    </section>
  );
};

const QualitySealSection: React.FC = () => {
    const qualitySealStyle = {
        backgroundImage: `url('images/city-lights-background.jpg')`,
        backgroundAttachment: 'fixed' as const,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    };

    return (
        <section
            className="py-24 bg-slate-900 text-white relative"
            style={qualitySealStyle}
        >
            <div className="absolute inset-0 bg-slate-900/70"></div>
            
            <div className="container mx-auto px-6 text-center relative z-10">
                <h2 className="text-4xl md:text-5xl font-black mb-4 text-yellow-400">
                    SERVICIO PREMIUM AAA+
                </h2>
                <p className="text-lg md:text-xl max-w-4xl mx-auto leading-loose text-slate-200">
                    No somos un simple gestor de multas. Somos tu equipo técnico-legal integral. Desde la gestión de sanciones y la elaboración de informes periciales hasta la representación en juzgados, nuestro compromiso es ofrecerte un servicio de máxima calidad, con transparencia, comunicación constante y un único objetivo: proteger tus derechos y tu bolsillo. Si, porque aunque nuestros servicios sean Premium, nuestros precios son Baratos.
                </p>
            </div>
        </section>
    );
};


const App: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isCookieModalOpen, setIsCookieModalOpen] = useState(false);
  const [isLegalNoticeModalOpen, setIsLegalNoticeModalOpen] = useState(false);
  const [isAboutUsModalOpen, setIsAboutUsModalOpen] = useState(false);
  const [isMultasEuModalOpen, setIsMultasEuModalOpen] = useState(false);
  const [isPeritajesEuModalOpen, setIsPeritajesEuModalOpen] = useState(false);
  const [isJuzgadosEuModalOpen, setIsJuzgadosEuModalOpen] = useState(false);
  const [isPricesModalOpen, setIsPricesModalOpen] = useState(false);
  const [isDelegationsModalOpen, setIsDelegationsModalOpen] = useState(false);
  const [isFranchiseModalOpen, setIsFranchiseModalOpen] = useState(false);
  const [isJobsModalOpen, setIsJobsModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isCreaAdModalOpen, setIsCreaAdModalOpen] = useState(false);
  const [userRole, setUserRole] = useState<'admin' | 'user' | null>(null);
  const [isFaqModalOpen, setIsFaqModalOpen] = useState(false);
  const [isSuccessStoriesModalOpen, setIsSuccessStoriesModalOpen] = useState(false);
  const [isCountryGuideModalOpen, setIsCountryGuideModalOpen] = useState(false);
  const [isDenunciaModalOpen, setIsDenunciaModalOpen] = useState(false);
  const [isNormativasVariasModalOpen, setIsNormativasVariasModalOpen] = useState(false);
  const [isPartnersModalOpen, setIsPartnersModalOpen] = useState(false);
  const [isThankYouModalOpen, setIsThankYouModalOpen] = useState(false);
  const [contactSubject, setContactSubject] = useState('Nuevo Contacto desde Multas.EU');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('form_submitted') === 'true') {
      setIsThankYouModalOpen(true);
      // Clean URL
      const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.replaceState({path: newUrl}, '', newUrl);
    }
  }, []);

  const handleToggleMenu = () => setIsMenuOpen(prev => !prev);
  const handleCloseMenu = () => setIsMenuOpen(false);

  const handleOpenContactModal = (subject?: string | React.MouseEvent<HTMLButtonElement>) => {
    if (typeof subject === 'string' && subject.trim() !== '') {
      setContactSubject(subject);
    } else {
      setContactSubject('Nuevo Contacto desde Multas.EU');
    }
    setIsContactModalOpen(true);
  };
  const handleCloseContactModal = () => setIsContactModalOpen(false);

  const handleOpenPrivacyModal = () => setIsPrivacyModalOpen(true);
  const handleClosePrivacyModal = () => setIsPrivacyModalOpen(false);

  const handleOpenCookieModal = () => setIsCookieModalOpen(true);
  const handleCloseCookieModal = () => setIsCookieModalOpen(false);

  const handleOpenLegalNoticeModal = () => setIsLegalNoticeModalOpen(true);
  const handleCloseLegalNoticeModal = () => setIsLegalNoticeModalOpen(false);

  const handleOpenAboutUsModal = () => setIsAboutUsModalOpen(true);
  const handleCloseAboutUsModal = () => setIsAboutUsModalOpen(false);

  const handleOpenMultasEuModal = () => setIsMultasEuModalOpen(true);
  const handleCloseMultasEuModal = () => setIsMultasEuModalOpen(false);
  
  const handleOpenPeritajesEuModal = () => setIsPeritajesEuModalOpen(true);
  const handleClosePeritajesEuModal = () => setIsPeritajesEuModalOpen(false);
  
  const handleOpenJuzgadosEuModal = () => setIsJuzgadosEuModalOpen(true);
  const handleCloseJuzgadosEuModal = () => setIsJuzgadosEuModalOpen(false);

  const handleOpenPricesModal = () => setIsPricesModalOpen(true);
  const handleClosePricesModal = () => setIsPricesModalOpen(false);

  const handleOpenDelegationsModal = () => setIsDelegationsModalOpen(true);
  const handleCloseDelegationsModal = () => setIsDelegationsModalOpen(false);

  const handleOpenFranchiseModal = () => setIsFranchiseModalOpen(true);
  const handleCloseFranchiseModal = () => setIsFranchiseModalOpen(false);

  const handleOpenJobsModal = () => setIsJobsModalOpen(true);
  const handleCloseJobsModal = () => setIsJobsModalOpen(false);
  
  const handleOpenLoginModal = () => setIsLoginModalOpen(true);
  const handleCloseLoginModal = () => setIsLoginModalOpen(false);

  const handleOpenRegisterModal = () => setIsRegisterModalOpen(true);
  const handleCloseRegisterModal = () => setIsRegisterModalOpen(false);
  
  const handleOpenCreaAdModal = () => setIsCreaAdModalOpen(true);
  const handleCloseCreaAdModal = () => setIsCreaAdModalOpen(false);

  const handleOpenFaqModal = () => setIsFaqModalOpen(true);
  const handleCloseFaqModal = () => setIsFaqModalOpen(false);

  const handleOpenSuccessStoriesModal = () => setIsSuccessStoriesModalOpen(true);
  const handleCloseSuccessStoriesModal = () => setIsSuccessStoriesModalOpen(false);

  const handleOpenCountryGuideModal = () => setIsCountryGuideModalOpen(true);
  const handleCloseCountryGuideModal = () => setIsCountryGuideModalOpen(false);

  const handleOpenDenunciaModal = () => setIsDenunciaModalOpen(true);
  const handleCloseDenunciaModal = () => setIsDenunciaModalOpen(false);

  const handleOpenNormativasVariasModal = () => setIsNormativasVariasModalOpen(true);
  const handleCloseNormativasVariasModal = () => setIsNormativasVariasModalOpen(false);
  
  const handleOpenPartnersModal = () => setIsPartnersModalOpen(true);
  const handleClosePartnersModal = () => setIsPartnersModalOpen(false);

  const handleCloseThankYouModal = () => setIsThankYouModalOpen(false);

  const handleLoginSuccess = (role: 'admin' | 'user') => {
    setUserRole(role);
    setIsLoginModalOpen(false);
  };
  
  const handleLogout = () => {
    setUserRole(null);
  };

  const switchToRegister = () => {
    setIsLoginModalOpen(false);
    setIsRegisterModalOpen(true);
  };

  const switchToLogin = () => {
    setIsRegisterModalOpen(false);
    setIsLoginModalOpen(true);
  };

  const isAnyModalOpen =
    isContactModalOpen ||
    isPrivacyModalOpen ||
    isCookieModalOpen ||
    isLegalNoticeModalOpen ||
    isAboutUsModalOpen ||
    isMultasEuModalOpen ||
    isPeritajesEuModalOpen ||
    isJuzgadosEuModalOpen ||
    isPricesModalOpen ||
    isDelegationsModalOpen ||
    isFranchiseModalOpen ||
    isJobsModalOpen ||
    isLoginModalOpen ||
    isRegisterModalOpen ||
    isCreaAdModalOpen ||
    isFaqModalOpen ||
    isSuccessStoriesModalOpen ||
    isCountryGuideModalOpen ||
    isDenunciaModalOpen ||
    isNormativasVariasModalOpen ||
    isPartnersModalOpen ||
    isThankYouModalOpen;

  const isOverlayVisible = isAnyModalOpen || isMenuOpen;


  if (userRole === 'admin') {
    return <Dashboard onLogout={handleLogout} />;
  }

  if (userRole === 'user') {
    return <UserDashboard onLogout={handleLogout} />;
  }

  return (
    <>
      <Header 
        isMenuOpen={isMenuOpen}
        onToggleMenu={handleToggleMenu}
        onCloseMenu={handleCloseMenu}
        onOpenPricesModal={handleOpenPricesModal}
        onOpenDelegationsModal={handleOpenDelegationsModal}
        onOpenFranchiseModal={handleOpenFranchiseModal}
        onOpenJobsModal={handleOpenJobsModal}
        onOpenLoginModal={handleOpenLoginModal}
        onOpenRegisterModal={handleOpenRegisterModal}
        onOpenCreaAdModal={handleOpenCreaAdModal}
        onOpenFaqModal={handleOpenFaqModal}
        onOpenSuccessStoriesModal={handleOpenSuccessStoriesModal}
        onOpenCountryGuideModal={handleOpenCountryGuideModal}
        onOpenContactModal={handleOpenContactModal}
        onOpenDenunciaModal={handleOpenDenunciaModal}
        onOpenNormativasVariasModal={handleOpenNormativasVariasModal}
        onOpenPartnersModal={handleOpenPartnersModal}
      />
      <main>
        <HeroSection onOpenModal={handleOpenContactModal} />
        <ServicesSection 
          onOpenMultasEuModal={handleOpenMultasEuModal}
          onOpenPeritajesEuModal={handleOpenPeritajesEuModal}
          onOpenJuzgadosEuModal={handleOpenJuzgadosEuModal}
        />
        <ServicesSlider onOpenContactModal={handleOpenContactModal} />
        <QualitySealSection />
        <AndorraBanner />
      </main>
      <Footer 
        onOpenPrivacyModal={handleOpenPrivacyModal}
        onOpenCookieModal={handleOpenCookieModal}
        onOpenLegalNoticeModal={handleOpenLegalNoticeModal}
        onOpenAboutUsModal={handleOpenAboutUsModal}
        onOpenContactModal={handleOpenContactModal}
      />

      {/* Modals */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={handleCloseContactModal}
        onOpenPrivacyModal={handleOpenPrivacyModal}
        onOpenCookieModal={handleOpenCookieModal}
        subject={contactSubject}
      />
      <PrivacyPolicyModal isOpen={isPrivacyModalOpen} onClose={handleClosePrivacyModal} />
      <CookiePolicyModal isOpen={isCookieModalOpen} onClose={handleCloseCookieModal} />
      <LegalNoticeModal isOpen={isLegalNoticeModalOpen} onClose={handleCloseLegalNoticeModal} />
      <AboutUsModal isOpen={isAboutUsModalOpen} onClose={handleCloseAboutUsModal} />
      <MultasEuModal isOpen={isMultasEuModalOpen} onClose={handleCloseMultasEuModal} onOpenContactModal={handleOpenContactModal} />
      <PeritajesEuModal isOpen={isPeritajesEuModalOpen} onClose={handleClosePeritajesEuModal} onOpenContactModal={handleOpenContactModal} />
      <JuzgadosEuModal isOpen={isJuzgadosEuModalOpen} onClose={handleCloseJuzgadosEuModal} onOpenContactModal={handleOpenContactModal} />
      <PricesModal isOpen={isPricesModalOpen} onClose={handleClosePricesModal} onOpenContactModal={handleOpenContactModal} />
      <DelegationsModal isOpen={isDelegationsModalOpen} onClose={handleCloseDelegationsModal} />
      <FranchiseModal isOpen={isFranchiseModalOpen} onClose={handleCloseFranchiseModal} onOpenContactModal={handleOpenContactModal} />
      <JobsModal isOpen={isJobsModalOpen} onClose={handleCloseJobsModal} onOpenContactModal={handleOpenContactModal} />
      <LoginModal 
        isOpen={isLoginModalOpen} 
        onClose={handleCloseLoginModal} 
        onSwitchToRegister={switchToRegister} 
        onLoginSuccess={handleLoginSuccess}
      />
      <RegisterModal 
        isOpen={isRegisterModalOpen} 
        onClose={handleCloseRegisterModal} 
        onSwitchToLogin={switchToLogin}
        onOpenContactModal={handleOpenContactModal}
      />
      <CreaAdModal
        isOpen={isCreaAdModalOpen}
        onClose={handleCloseCreaAdModal}
        onOpenContactModal={handleOpenContactModal}
      />
      <FaqModal isOpen={isFaqModalOpen} onClose={handleCloseFaqModal} />
      <SuccessStoriesModal isOpen={isSuccessStoriesModalOpen} onClose={handleCloseSuccessStoriesModal} />
      <CountryGuideModal isOpen={isCountryGuideModalOpen} onClose={handleCloseCountryGuideModal} />
      <DenunciaModal
        isOpen={isDenunciaModalOpen}
        onClose={handleCloseDenunciaModal}
        onOpenContactModal={handleOpenContactModal}
      />
      <NormativasVariasModal isOpen={isNormativasVariasModalOpen} onClose={handleCloseNormativasVariasModal} />
      <PartnersModal 
        isOpen={isPartnersModalOpen} 
        onClose={handleClosePartnersModal} 
        onOpenContactModal={handleOpenContactModal}
      />
      <ThankYouModal isOpen={isThankYouModalOpen} onClose={handleCloseThankYouModal} />

      <WhatsAppButton isVisible={!isOverlayVisible} />
    </>
  );
};

export default App;